<template>
  <Content :top="0" :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-cell-group title="上次访问">
      <van-cell
        icon="location-o"
        :title="
          accessVo.roleId
            ? `${accessVo.companyName}(${accessVo.roleName})`
            : accessVo.accSysName
        "
        is-link
        @click="handleItemClick(accessVo, 'prev')"
      />
    </van-cell-group>
    <!--    <van-cell-group title="推荐">-->
    <!--      <van-cell v-for="itemRec in systemVoList" :key="itemRec.sysId" icon="location-o" :title="itemRec.sysName" is-link @click="handleItemClick(itemRec, 'sys')" />-->
    <!--    </van-cell-group>-->
    <van-cell-group title="全部角色">
      <van-cell
        v-for="itemRec in roleVoList"
        :key="itemRec.roleId"
        icon="location-o"
        :title="
          itemRec.departName
            ? `${itemRec.companyName}${itemRec.departName}(${itemRec.roleName})`
            : `${itemRec.companyName}(${itemRec.roleName})`
        "
        is-link
        @click="handleItemClick(itemRec, 'role')"
      />
    </van-cell-group>
    <!--    <van-cell-group title="全部应用">-->
    <!--      <van-cell v-for="item in systemVoList" :key="item.sysId" icon="location-o" :title="item.sysName" is-link @click="handleItemClick(item, 'sys')" />-->
    <!--    </van-cell-group>-->
    <van-cell-group title="其他">
      <van-cell title="切换登录" to="/login" is-link />
    </van-cell-group>
  </Content>
</template>

<script>
import { Toast } from 'vant'
import { reactive, toRefs, computed } from 'vue'
import { getSystemList, addAccessInfo, getNoticeList } from '@/api/welcome'
import { useRouter, useRoute } from 'vue-router'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { useStore } from 'vuex'
export default {
  name: 'Welcome',
  setup() {
    const router = useRouter()
    const store = useStore()
    const username = computed(() => store.state.userInfo.username)
    const roleInfo = computed(() => store.state.roleInfo)
    const { query } = useRoute()

    // 获取列表
    const state = reactive({
      accessVo: {},
      systemVoList: [],
      roleVoList: []
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getSystemList,
      data => {
        for (const key in data) {
          state[key] = data[key]
        }
      }
    )
    getDataLoading()

    // 选择角色
    const handleItemClick = (item, type) => {
      store.dispatch('setRoleInfo', item)
      let params = null
      let url = ''
      switch (type) {
        case 'prev':
          console.log(item)
          params = {
            accSys: item.accSysId,
            roleId: item.roleId,
            companyId: item.companyId,
            departId: item.departId,
            empId: item.empId
          }
          url = item.accUrl
          break
        case 'sys':
          params = {
            accSys: item.sysId
          }
          url = item.accUrl
          break
        case 'role':
          params = {
            accSys: '3',
            roleId: item.roleId,
            companyId: item.companyId,
            departId: item.departId,
            empId: item.empId
          }
          url = item.roleAccUrl
          break
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: '查询通知...'
      })
      useGetData(
        getNoticeList,
        data => {
          if (data.length) {
            Toast.clear()
            router.push(`/notice/${item.roleId}/${username.value}`)
          } else {
            toPath(params, item, url)
          }
          // Toast.clear()
        },
        () => Toast.clear()
      )({ roleId: item.roleId, username: username.value })
    }
    // 角色跳转
    const toPath = (params, item, url) => {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: '正在跳转...'
      })
      useGetData(
        addAccessInfo,
        data => {
          Toast.clear()
          if (item.roleId) {
            router.push(url)
          } else {
            window.location.href = url
          }
        },
        () => Toast.clear()
      )(params)
    }
    if (query.notice === '0') {
      handleItemClick(roleInfo.value, 'role')
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      ...toRefs(state),
      handleItemClick
    }
  }
}
</script>

<style scoped></style>
